module.exports = __webpack_public_path__ + "childcare_line.svg?ad468f1bf561fe34843e6b4a9c948f7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/childcare_line.svg
// module id = 111
// module chunks = 0